import { render } from "./CourseRow.vue?vue&type=template&id=5c804849"
import script from "./CourseRow.vue?vue&type=script&lang=js"
export * from "./CourseRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__